import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService, ModalService } from 'cl-common-angular';

@Injectable({
    providedIn: 'root'
})
export class LogService extends LoggerService {

    routePrefix = 'api/logging/log';

    constructor(protected httpClient: HttpClient,
        protected modalService: ModalService) {
        super(httpClient, modalService);
    }
}
